<template>
  <div style="padding: 14px 0; display: flex;" class="flex-center">
    <b-row align-h="between" style="flex: 1;">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('INDEX.form_label_choose_sys_user') ||
                  '姓名/公司/部门 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <div class="flex-center">
      <span>
        <span class="label_text">已选</span>
        <span class="label_checked_count">{{ checkedCount }}</span>
        <span class="label_text">人</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      form: {
        searchKey: '',
        userStatusList: ['Y'],
      },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },

    reset() {
      this.form = {
        searchKey: '',
        userStatusList: ['Y'],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.label_text {
  font-size: 14px;
  color: #8f97ad;
}
.flex-center {
  display: flex;
  align-items: center;
}
.label_checked_count {
  margin: 0 8px;
  color: #071437;
  font-size: 14px;
}
</style>
